export const Sources = {
  optaLogoMen: 'https://storage.googleapis.com/static-production.netcosports.com/directv/OPTA_LOGOS/',
  optaLogoWomen: 'https://storage.googleapis.com/static-production.netcosports.com/optasd_logos/',
};
